export enum ActorTypes {
  Anchor = "Anchor",
  Vendor = "Vendor",
  Admin = "Admin",
}

export interface FrontendActor {
  id: number;
  name: string;
  actorType: ActorTypes;
  email: string;
  mfaEnabled: boolean;
  mfaVerified: boolean;
  actorId: number;
}
